module.exports = __webpack_public_path__ + "static/media/Machamp_gaussian2.589e543d.png";